import API from "../../../helpers/devApi";

const API_ENDPOINTS = "/hrms_employee";
// const API_ENDPOINTS = "http://localhost:6004/api/v1/hrms_employee";

export function getAllEmployeeList(payload) {
  return API.post(`hrms_employee/get-all-employee`, payload);
}
export function getEmployeeProfile(id) {
  return API.get(`${API_ENDPOINTS}/${id}`);
}
export function getEmployeeTransfer(id) {
  return API.get(`${API_ENDPOINTS}/transfer/view/${id}`);
}
export function getEmployeeUnit(id) {
  return API.get(`${API_ENDPOINTS}/get/default/const/center/by/employee/${id}`);
}
export function getSupervisorList(id) {
  return API.get(`${API_ENDPOINTS}/get-supervisor-list/${id}`);
}

export function getOneSupervisorAssign(id) {
  return API.get(`/hrms_supervisor_assign/${id}`);
}
export function getDocumentByEmployeeId(employeeId) {
  return API.get(
    `/hrms_document_employee_onboarding/get-data-by-employee_id/${employeeId}`
  );
}

export function getDocumentByDesigCategory(params) {
  return API.get(`/hrms_employee/document/master/data`);
}

export function getEmployeeCategoriesList() {
  return API.get(`/hrms_employee_categories`);
}

export function getEmployeeGradeList() {
  return API.get(`/hrms_grade`);
}

export function getAcademicRanks() {
  return API.get(`/hrms-payroll-service/course-credit/getAllRanks`);
}

export function getTrainingList(id) {
  return API.get(`/hrms_user_training/byUserId/${id}`);
}
export function getCertificationsList(id) {
  return API.get(`/hrms_user_professional_certification/byUserId/${id}`);
}

export function getEducationForEmployee(id) {
  return API.get(`/hrms_user_education/byUserId/${id}`);
}

export function insertProfileScore(params, user_id) {
  return API.post(`/hrms_user_profile_percentage/${user_id}`, { name: params });
}

export function updateProfileScore(params, user_id) {
  return API.patch(`/hrms_user_profile_percentage/${user_id}`, {
    name: params,
  });
}

export function getDocumentChecklistCategory() {
  return API.get(`/hrms_documentation_checklist_type`);
}
export function getDocumentChecklistEmployee(id) {
  return API.get(`/hrms_user_documentation_checklist/get_data_by_user/${id}`);
}

export function insertDocumentCheckListInfo(params) {
  return API.post(`/hrms_user_documentation_checklist`, params);
}

export function getEmployeeTimeLineUrl(id) {
  return API.get(`/hrms_employee_event/byUserId/${id}`);
}
